module.exports = "<router-outlet></router-outlet>\n<p-toast position=\"top-right\"></p-toast>"